import React, { useEffect, useState } from 'react'
import { useTheme } from '@mui/material/styles'
import {
  Box,
  CircularProgress,
  FormLabel,
  Grid,
  Modal,
  styled,
  Typography,
  FormControl,
  Button,
  DialogActions,
  Fade,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
} from '@mui/material'
import lightTheme from '../../styles/theme/lightTheme'
import '../../styles/components/_box.scss'
import '../../styles/components/_grids.scss'
import '../../styles/components/_inputs.scss'
import { SelectBasic } from '../inputs'
import Api from '../../services/api.service'
import { handlingErrors } from '../../utils'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import * as yup from 'yup'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleExclamation,
  faXmark,
  faClock,
  faCalendarAlt,
  faSun,
  faMoon,
} from '@fortawesome/pro-solid-svg-icons'
import { duree, dureeEntre, horaires } from '../../pages/Admin/Calendar/config'
import OutlineButton from '../buttons/OutlineButton'
import GradientButton from '../buttons/GradientButton'

const TitleSection = styled(Typography)(({ theme }) => ({
  fontFamily: 'Century Gothic Bold',
  fontSize: 14,
  lineHeight: '140%',
  color: lightTheme.palette.primary.main,
  letterSpacing: '0.2px',
  textTransform: 'uppercase',
}))

const SelectControl = styled(FormControl)(({ theme }) => ({
  display: 'flex',
  /*justifyContent: "center",
  alignItems: "center",
  columnGap: "20px",*/
  /*flexDirection: "row",*/

  flexDirection: 'column',

  '& .day-label': {
    fontFamily: 'Century Gothic Bold',
    fontSize: 15,
    lineHeight: '140%',
    letterSpacing: '0.2px',
    color: lightTheme.palette.text.primary,
  },
}))

const SlotLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '15px',
}))

const SlotContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}))

const SlotSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  columnGap: '20px',
}))

const SlotBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  columnGap: '10px',
}))

const schema = yup.object({
  dureeRdv: yup.string().notOneOf([''], 'Merci de sélectionner une valeur'),
  dureeEntreRdv: yup
    .string()
    .notOneOf([''], 'Merci de sélectionner une valeur'),
  disponibilites: yup.mixed().required(),
})

const ModalContainer = styled(Box)(({ theme }) => ({
  width: 'calc(100% - 32px)',
  maxWidth: 800,
  minHeight: 400,
  maxHeight: '90vh',
  backgroundColor: '#FFFFFF',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '16px',
  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
  padding: '32px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',

  '&:focus-visible': {
    outline: 'none',
  },

  [theme.breakpoints.up('sm')]: {
    width: 800,
    padding: '20px 40px',
  },
}))

const BoxContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}))

const EditDisponibilite = ({
  open,
  onClose,
  onSave,
  openDelete,
  user,
  role,
}) => {
  const { t, i18n } = useTranslation()

  const [loadingInfos, setLoadingInfos] = useState(true)
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)
  const [snapShot, setSnapShot] = useState(user ? user : null)
  const [isDuree, setIsDuree] = useState(
    user.entreprise?.dureeRdv ? user.entreprise?.dureeRdv : ''
  )
  const [isDureeEntre, setIsDureeEntre] = useState(
    user.entreprise?.dureeEntreRdv ? user.entreprise?.dureeEntreRdv : ''
  )
  const [slotDefaultValue, setSlotDefaultValue] = useState(
    user.entreprise?.disponibilites ? user.entreprise?.disponibilites : []
  )

  const { reset } = useForm({
    resolver: yupResolver(schema),
  })

  const handleDureeSelect = (event) => {
    const inputValue = event.target.value
    setIsDuree(inputValue)
  }

  const handleDureeEntreSelect = (event) => {
    const inputValue = event.target.value
    setIsDureeEntre(inputValue)
  }

  const handleChangeSelect = (event) => {
    const inputValue = event.target.value
    const slotDay = event.target.dataset.day
    const slotTime = event.target.dataset.time
    slotDefaultValue.forEach((slot, index) => {
      if (slot[0] === slotDay) {
        switch (slotTime) {
          case '1':
            slot[1][0] = inputValue + '-' + slot[1][0].split('-')[1]
            break
          case '2':
            slot[1][0] = slot[1][0].split('-')[0] + '-' + inputValue
            break
          case '3':
            slot[1][1] = inputValue + '-' + slot[1][1].split('-')[1]
            break
          case '4':
            slot[1][1] = slot[1][1].split('-')[0] + '-' + inputValue
            break
          default:
            break
        }
      }
    })
    setSlotDefaultValue(slotDefaultValue)
  }

  useEffect(() => {
    fetchData()
  }, [user, dispatch, reset])

  const fetchData = async () => {
    setSnapShot(user)
    setSlotDefaultValue(user.entreprise?.disponibilites)
    setIsDuree(user.entreprise?.dureeRdv)
    setIsDureeEntre(user.entreprise?.dureeEntreRdv)
    reset(user)
    setLoadingInfos(false)
  }

  const editDisponibilites = async () => {
    setLoading(true)
    const result = await Api.company.edit(snapShot.entreprise.id, {
      disponibilites: slotDefaultValue,
      dureeRdv: parseInt(isDuree),
      dureeEntreRdv: parseInt(isDureeEntre),
    })
    const handling = handlingErrors(result)

    if (handling.status === 401) {
      toast.error(t('successMessage.sessionExpired'), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        icon: ({ theme, type }) => (
          <FontAwesomeIcon
            icon={faCircleExclamation}
            fontSize={25}
            color={lightTheme.palette.error.main}
          />
        ),
      })
      window.scrollTo(0, 0)
      return
    }

    if (handling.ok) {
      setLoading(false)
      onSave()
    } else {
      setLoading(false)
    }
  }
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={fullScreen}
      scroll={'paper'}
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : '16px',
          p: fullScreen ? 0 : '8px',
          m: fullScreen ? 0 : undefined,
          maxHeight: fullScreen ? '100%' : '90vh',
          ...(fullScreen && {
            display: 'flex',
            flexDirection: 'column',
          }),
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
          px: { xs: 2, sm: 3 },
          py: { xs: 1.5, sm: 2 },
          pb: 2,
          flexShrink: 0,
          borderBottom: '1px solid rgba(229, 231, 235, 0.8)',
          backgroundColor: 'rgba(249, 250, 251, 0.5)',
        }}
      >
        <Typography
          variant={fullScreen ? 'subtitle1' : 'h6'}
          sx={{ fontWeight: 600, color: '#1f2937', pr: 1, lineHeight: 1.3 }}
        >
          {t('box.title.editDisponibilite')}
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: '#6b7280',
            '&:hover': {
              backgroundColor: 'rgba(107, 114, 128, 0.1)',
              color: '#374151',
            },
          }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 4, pt: '32px !important' }}>
        {loadingInfos ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 200,
              backgroundColor: '#f9fafb',
              borderRadius: '12px',
              border: '2px dashed #e5e7eb',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
              }}
            >
              <CircularProgress
                size={32}
                sx={{
                  color: '#667eea',
                  '& .MuiCircularProgress-circle': {
                    strokeLinecap: 'round',
                  },
                }}
              />
              <Typography
                sx={{
                  color: '#6b7280',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                {t('home.slots')}
              </Typography>
            </Box>
          </Box>
        ) : (
          <div style={{ width: '100%' }}>
            <form>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 3,
                  mb: 3,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: '#374151',
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <FontAwesomeIcon
                    icon={faClock}
                    color="#667eea"
                    fontSize={16}
                  />
                  {t('box.choixTemporelles')}
                </Typography>
                <Grid container spacing={2} className={'gridContainer'}>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: '#374151',
                          fontSize: '14px',
                        }}
                      >
                        {t('box.dureeRDV')}
                      </Typography>
                      <SelectBasic
                        items={duree}
                        defaultValue={snapShot?.entreprise?.dureeRdv}
                        handleChange={handleDureeSelect}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: '#374151',
                          fontSize: '14px',
                        }}
                      >
                        {t('box.dureeEntreRDV')}
                      </Typography>
                      <SelectBasic
                        items={dureeEntre}
                        defaultValue={snapShot?.entreprise?.dureeEntreRdv}
                        handleChange={handleDureeEntreSelect}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 3,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: '#374151',
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    color="#667eea"
                    fontSize={16}
                  />
                  {t('box.joursHorairesDisponibilites')}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    maxHeight: 400,
                    overflowY: 'auto',
                    padding: 1,
                    backgroundColor: '#f9fafb',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',

                    '&::-webkit-scrollbar': {
                      width: 6,
                    },

                    '&::-webkit-scrollbar-track': {
                      background: 'transparent',
                    },

                    '&::-webkit-scrollbar-thumb': {
                      background: '#d1d5db',
                      borderRadius: 3,
                    },

                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#9ca3af',
                    },
                  }}
                >
                  {user &&
                    user.entreprise &&
                    user.entreprise.disponibilites.map((item) => (
                      <Box
                        key={item[0]}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          p: 2,
                          backgroundColor: '#ffffff',
                          borderRadius: '8px',
                          border: '1px solid #e5e7eb',
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#6b7280',
                            textTransform: 'capitalize',
                          }}
                        >
                          {t(`box.${item[0]}`)}
                        </Typography>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              mb: 1,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faSun}
                              color="#f59e0b"
                              fontSize={14}
                            />
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 600,
                                color: '#92400e',
                              }}
                            >
                              {t('box.matin')}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                            }}
                          >
                            <SelectBasic
                              items={horaires[i18n.language]}
                              dataDay={item[0]}
                              dataTime={1}
                              defaultValue={
                                item[1][0].split('-')[0] &&
                                item[1][0].split('-')[0].substring(0, 5)
                              }
                              handleChange={handleChangeSelect}
                            />
                            <Typography
                              sx={{
                                fontSize: '12px',
                                color: '#6b7280',
                                fontWeight: 500,
                              }}
                            >
                              {t('box.in')}
                            </Typography>
                            <SelectBasic
                              items={horaires[i18n.language]}
                              dataDay={item[0]}
                              dataTime={2}
                              defaultValue={
                                item[1][0].split('-')[1] &&
                                item[1][0].split('-')[1].substring(0, 5)
                              }
                              handleChange={handleChangeSelect}
                            />
                          </Box>
                        </Box>

                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              mb: 1,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faMoon}
                              color="#6366f1"
                              fontSize={14}
                            />
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 600,
                                color: '#4338ca',
                              }}
                            >
                              {t('box.apresMidi')}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                            }}
                          >
                            <SelectBasic
                              items={horaires[i18n.language]}
                              dataDay={item[0]}
                              dataTime={3}
                              defaultValue={
                                item[1][1].split('-')[0] &&
                                item[1][1].split('-')[0].substring(0, 5)
                              }
                              handleChange={handleChangeSelect}
                            />
                            <Typography
                              sx={{
                                fontSize: '12px',
                                color: '#6b7280',
                                fontWeight: 500,
                              }}
                            >
                              {t('box.in')}
                            </Typography>
                            <SelectBasic
                              items={horaires[i18n.language]}
                              dataDay={item[0]}
                              dataTime={4}
                              defaultValue={
                                item[1][1].split('-')[1] &&
                                item[1][1].split('-')[1].substring(0, 5)
                              }
                              handleChange={handleChangeSelect}
                            />
                          </Box>
                        </Box>
                      </Box>
                    ))}
                </Box>
              </Box>
            </form>
          </div>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          px: { xs: 2, sm: 4 },
          py: 3,
          gap: 2,
          justifyContent: 'center',
          backgroundColor: 'rgba(249, 250, 251, 0.8)',
          borderTop: '1px solid rgba(229, 231, 235, 0.8)',
          flexDirection: { xs: 'column', sm: 'row' },
          flexShrink: 0,
          '& > *': {
            width: { xs: '100%', sm: 'auto' },
            m: 0,
          },
        }}
      >
        <OutlineButton onClick={onClose} fullWidth={fullScreen}>
          {t('button.cancel')}
        </OutlineButton>

        <GradientButton onClick={editDisponibilites} fullWidth={fullScreen}>
          {loading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1, color: 'white' }} />
              {t('profile.saving')}
            </>
          ) : (
            t('button.save')
          )}
        </GradientButton>
      </DialogActions>
    </Dialog>
  )
}

export default EditDisponibilite
